module.exports = __webpack_public_path__ + "static/media/genba-monogram-blanc.67d77627.svg";